<template>
  <div>
    <el-row id="tabBarNav">
      <el-col>
        <el-form :inline="true">
          <el-form-item label="关键字:">
            <el-input
              v-model="filters.keyWord"
              placeholder="请输入姓名/手机号/身份证号"
              clearable
              @clear="handleClear"
              style="width:300px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位名称:">
            <el-input
              v-model="filters.socialUnitName"
              placeholder="请输入单位名称"
              clearable
              @clear="handleClear"
            ></el-input>
          </el-form-item>
          <el-form-item label="岗位名称:">
            <el-select
              v-model="filters.stationId"
              style="width: 160px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in stationList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业名称:">
            <el-select
              v-model="filters.tradeId"
              style="width: 160px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in tradeList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="是否游客:">
            <el-select
              v-model="filters.isTourist"
              style="width: 120px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签到日期:">
            <el-date-picker
								v-model="filters.examDate"
								type="daterange"
								format="yyyy 年 MM 月 dd 日"
								value-format="yyyy-MM-dd"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
						>
						</el-date-picker>
          </el-form-item>
          <div style="display:inline-block;margin-right:10px;margin-top:6px;margin-left:10px;">
             <el-checkbox v-model="filters.isDistinct" @change="isDistinctChange">签到去重</el-checkbox>
              <div style="color:red;font-size:14px;">说明：默认勾选，勾选后只显示同个账号，签到时间最早的那条记录</div>
          </div> 
      
          <el-form-item>
            <toolbar
              :buttonList="buttonList"
              @callFunction="callFunction"
            ></toolbar>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      border
      v-loading="listLoading"
      highlight-current-row
      :header-row-style="{ height: '47px' }"
      style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column
        prop=""
        type="index"
        label="序号"
        align="center"
        :index="indexMethod"
        width="60"
      ></el-table-column>
      <el-table-column
        prop="AccountName"
        label="学生姓名"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机号"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="CardNo"
        label="身份证号"
        align="center"
        min-width="110"
      ></el-table-column>
      <el-table-column
        prop="StationName"
        label="岗位名称"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="TradeName"
        label="行业名称"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="UnitName"
        label="单位名称"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="签到时间"
        align="center"
        min-width="110"
      ></el-table-column>
       <el-table-column
        prop="TeacherName"
        label="签到老师"
        align="center"
        min-width="110"
      ></el-table-column>
       <el-table-column
        prop="EnrollTime"
        label="报名时间"
        align="center"
        min-width="110"
      ></el-table-column>
    
    </el-table>
    <!--底部工具条-->
    <el-col
      :span="24"
      class="pageBar"
      style="padding-bottom: 22px; margin-top: -12px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>
  </div>
</template>
<script>
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {
  getStudentExamEnrollInfoSignPageApi,
  getStationTradeList,
  exportStudentExamEnrollInfoSignApi,
} from "../../api/api";
import util from "../../../util/date";
export default {
  components: { Toolbar },
  data() {
    return {
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      filters: {
        stationId: undefined, //岗位ID
        tradeId: undefined, //行业信息ID
        keyWord: undefined, //搜索关键字
        socialUnitName: undefined, //单位名称
        isTourist: undefined, 
        examDate:undefined,
        isDistinct:true
      },
      stationList: [],
      tradeList: [],
      options: [
        { value: true, name: "是" },
        { value: false, name: "否" },
      ],
      buttonList: [],
      tableData: [],
      listLoading: false
    };
  },
  methods: {
    // 获取行业名称
    async getTradeTypeData() {
      let params = {
        dataType: 0,
      };
      const res = await getStationTradeList(params);
      if (res.data.Success) {
        this.tradeList = res.data.Response;
      }
    },
    //获取岗位名称
    async getStationList() {
      let params = {
        dataType: 1,
      };
      const res = await getStationTradeList(params);
      if (res.data.Success) {
        this.stationList = res.data.Response;
      }
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    // 清除input框，重新获取数据
    handleClear() {
      this.getDataList();
    },
    // 获取分页列表
    getDataList() {
      let params = {
        pageIndex: this.pages.pageIndex, //当前页
        pageSize: this.pages.pageSize, //每页条数
        stationId: this.filters.stationId, //岗位ID
        tradeId: this.filters.tradeId, //行业信息ID
        keyWord: this.filters.keyWord, //搜索关键字
        socialUnitName: this.filters.socialUnitName, //单位名称
        isTourist: this.filters.isTourist, 
        startTime:this.filters.examDate?this.filters.examDate[0]:undefined,
        endTime:this.filters.examDate?this.filters.examDate[1]:undefined,
        isDistinct:this.filters.isDistinct

      };
      this.listLoading = true;
      getStudentExamEnrollInfoSignPageApi(params).then((res) => {
        let result = res.data;
        if (result.Success) {
          this.tableData = result.Response.Data;
          this.pages.dataCount = result.Response.DataCount;
        } else {
          this.tableData = [];
          this.pages.dataCount = 0;
        }
        this.listLoading = false;
      });
    },
    // 查询
    getListData() {
      this.pages.pageIndex = 1;
      this.pages.pageSize = 20;
      this.getDataList();
    },
  
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getDataList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getDataList();
    },
    

    // 表格数据分页条数累计
    indexMethod(index) {
      let currentPage = this.pages.pageIndex;
      let pageSize = this.pages.pageSize;
      return index + 1 + (currentPage - 1) * pageSize;
    },
    exportExcel() {
      this.$confirm('确定导出吗？',"提示",{}).then(() => {
          let params = {
            stationId: this.filters.stationId ? this.filters.stationId : undefined, //岗位ID
            tradeId: this.filters.tradeId ? this.filters.tradeId : undefined, //行业信息ID
            keyWord: this.filters.keyWord ? this.filters.keyWord : undefined, //搜索关键字
            socialUnitName: this.filters.socialUnitName
              ? this.filters.socialUnitName
              : undefined, //单位名称
            isTourist: this.filters.isTourist ? this.filters.isTourist : undefined, 
            startTime:this.filters.examDate?this.filters.examDate[0]:undefined,
            endTime:this.filters.examDate?this.filters.examDate[1]:undefined,
            isDistinct:this.filters.isDistinct
          };
          exportStudentExamEnrollInfoSignApi(params).then((res) => {
            if(res.status==200){
              let fileName  = "签到记录.xlsx"
              // 创建Blob对象
              let blob = new Blob([res.data], {type: "content-type"})
              // 创建临时链接并触发下载
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              // 清理资源
              document.body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
              this.$message.success(res.statusText)
            }else{
              this.$message.warning(res.statusText)
            }
          })
        })
    },
    isDistinctChange(){
        this.getDataList()
    }
  },
  watch: {
    
  },
  mounted() {
    this.getStationList();
    this.getTradeTypeData();
    this.getListData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);

      

   
  },
};
</script>
<style lang="stylus" scoped>
.el-textarea>>>.el-textarea__inner {
  min-height: 100px !important;
}

#tabBarNav .el-form-item {
  margin-bottom: 8px;
}
</style>
<style>
.el-tooltip__popper {
  max-width: 500px;
}
</style>